/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Status
 */
export interface Status {
    /**
     * 
     * @type {StatusStatusCodeEnum}
     * @memberof Status
     */
    statusCode?: StatusStatusCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    message?: string;
}


/**
 * @export
 */
export const StatusStatusCodeEnum = {
    Err0001: 'ERR0001',
    Err0002: 'ERR0002',
    Err0003: 'ERR0003'
} as const;
export type StatusStatusCodeEnum = typeof StatusStatusCodeEnum[keyof typeof StatusStatusCodeEnum];


/**
 * Check if a given object implements the Status interface.
 */
export function instanceOfStatus(value: object): value is Status {
    return true;
}

export function StatusFromJSON(json: any): Status {
    return StatusFromJSONTyped(json, false);
}

export function StatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): Status {
    if (json == null) {
        return json;
    }
    return {
        
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function StatusToJSON(json: any): Status {
    return StatusToJSONTyped(json, false);
}

export function StatusToJSONTyped(value?: Status | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'statusCode': value['statusCode'],
        'message': value['message'],
    };
}

